import { SimulatedCampaignsTable } from "./SimulatedCampaignsTable";
import { SimulatedResultsTimeline } from "./SimulatedResultsTimeline";

interface Props {
  results: any;
}

export const Summary = ({ results }: Props) => {
  return (
    <>
      <SimulatedCampaignsTable items={results} />
      <SimulatedResultsTimeline items={results} />
    </>
  );
};
